import type { PaymentType } from '#src/app/shared/utils/payments';

import { usePromoteFormData } from '../../../formContext/formData';
import { usePromoteFormState } from '../../../formContext/formState';
import { useCanUserUpdateFields } from '../useCanUserUpdateFields';

export function useUserInfo(): (paymentType: PaymentType) => { firstName: string; lastName: string; email: string } {
	const [{ firstName, lastName }] = usePromoteFormState();
	// Note: email comes from formData.user.email since formState doesn't have email
	const { guestUserData, user } = usePromoteFormData();
	const canUserUpdateFields = useCanUserUpdateFields();

	return function userInfo(paymentType) {
		if (canUserUpdateFields(paymentType)) {
			// Use state values for names, user.email for email
			return { firstName, lastName, email: user.email };
		}

		// These fields can only be empty when guest user lands to promote page directly
		// we don't expect that to happen on production. User should be coming to promote page through petition
		// sign and psf page. but we should keep an eye on possible invalid form submit errors on
		// promote page specifically for email field
		const {
			firstName: guestFirstName,
			lastName: guestLastName,
			email: guestEmail,
		} = guestUserData || {
			firstName: '',
			lastName: '',
			email: user.email,
		};

		return { firstName: guestFirstName, lastName: guestLastName, email: guestEmail };
	};
}
